interface RequireFieldValidator {
  (input: string): boolean;
}

export const requiredFieldValidator: RequireFieldValidator = (input) => {
  if (!input.trim().length) {
    return false;
  }
  return true;
};
